import { useState, useCallback } from "react"
import type { ToastProps, ToastOptions } from "@/types/toast"

function useToast() {
  const [state, setState] = useState<{ toasts: ToastProps[] }>({ toasts: [] })

  const toast = useCallback((props: ToastOptions) => {
    const id = Math.random().toString(36).substring(2, 9)
    const newToast = { id, ...props }

    setState((state) => ({
      ...state,
      toasts: [newToast, ...state.toasts].slice(0, 1),
    }))

    return {
      id,
      dismiss: () => setState((state) => ({
        ...state,
        toasts: state.toasts.filter((t) => t.id !== id),
      })),
      update: (props: ToastOptions) =>
        setState((state) => ({
          ...state,
          toasts: state.toasts.map((t) =>
            t.id === id ? { ...t, ...props } : t
          ),
        })),
    }
  }, [])

  return {
    toast,
    toasts: state.toasts,
    dismiss: (toastId?: string) =>
      setState((state) => ({
        ...state,
        toasts: state.toasts.filter((t) => t.id !== toastId),
      })),
  }
}

export { useToast } 